import { SVGProps, Ref, forwardRef } from 'react';

export const CopyOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M1.553 3.291c-.11.582-.153 1.387-.153 2.543s.043 1.961.153 2.543c.107.568.253.782.354.884.1.1.315.246.883.353A9 9 0 0 0 4 9.74v1.402c-3.465-.157-4-1.128-4-5.308C0 1.167.667.5 5.333.5c3.658 0 4.858.41 5.207 2.834H9.122l-.008-.043c-.107-.568-.253-.783-.354-.884s-.316-.247-.884-.354C7.295 1.943 6.49 1.9 5.333 1.9s-1.96.044-2.543.153c-.568.107-.782.253-.883.354s-.247.316-.354.884"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.333 10.164c0-4.667.667-5.333 5.333-5.333S16 5.497 16 10.164s-.667 5.333-5.334 5.333-5.333-.666-5.333-5.333m1.4 0c0-1.156.043-1.961.153-2.543.107-.568.253-.783.354-.884s.315-.247.883-.354c.582-.11 1.387-.152 2.543-.152s1.962.043 2.543.152c.568.107.783.253.884.354s.247.316.354.884c.11.582.153 1.387.153 2.543s-.044 1.961-.153 2.543c-.107.568-.253.782-.354.884-.101.1-.316.246-.884.353-.581.11-1.387.153-2.543.153s-1.96-.043-2.543-.153c-.568-.107-.782-.252-.883-.353s-.247-.316-.354-.884c-.11-.582-.153-1.387-.153-2.543"
                fill="currentColor"
            />
        </g>
    </svg>
));
CopyOutlinedSize16Glyph.displayName = 'CopyOutlinedSize16Glyph';
